const apiKey = "3757cd1285ba55a2aac90b04596bb043";
export default apiKey;
